import React, { useRef } from 'react';

import { createInternalContext } from '~/shared/contexts/createInternalContext';

import type { WatchingSectionState } from './types';
import { useScrollToSection } from './useScrollToSection';
import { useSyncActiveSectionClass } from './useSyncActiveSectionClass';
import { useSyncSectionHash } from './useSyncSectionHash';
import { useWatchingSectionState } from './useWatchingSectionState';

type Props = {
  children: React.ReactElement[];
  location: Location;
};

const [WatchingSectionStateProvider, useWatchingSection] = createInternalContext<WatchingSectionState>({
  name: 'WatchingSection',
});

export const WatchingSectionProvider: React.FC<Props> = ({ children, location }: Props) => {
  const visibleSectionsRef = useRef<HTMLElement[]>([]);
  const scrollToSection = useScrollToSection(visibleSectionsRef);
  const { activeSectionId, visibleSectionIds } = useWatchingSectionState({
    pathname: location.pathname,
    scrollToSection,
    visibleSectionsRef,
  });

  useSyncActiveSectionClass({
    activeSectionId,
    visibleSectionIds,
    visibleSectionsRef,
  });
  useSyncSectionHash(activeSectionId);

  return (
    <WatchingSectionStateProvider
      value={{
        activeSectionId,
        visibleSectionIds,
        scrollToSection,
      }}
    >
      {children}
    </WatchingSectionStateProvider>
  );
};

export default useWatchingSection;
